/* eslint-disable @typescript-eslint/camelcase */
import { IconType } from '../../ui/icon/icon';
import { IGk } from './gks';

// export type Citizenship = 'any';

export interface IRSBank {
  id: number;
  title: string;
  gksList?: string[];
  color?: string;
  fullTitle?: string;
  textColor?: string;
  iconStyle?: object;
  isDisabled?: boolean;
  mortgageByRegion: { [key: string]: IMortgage };
  // TODO: может быть когда-нибудь пришлют данные по комиссии и гражданству
  // commission?: boolean;
  // citizenship?: Citizenship;
}

export interface IBank {
  id: number;
  title: string;
  gksList?: string[];
  icon?: IconType;
  color?: string;
  fullTitle?: string;
  textColor?: string;
  iconStyle?: React.CSSProperties;
  isDisabled?: boolean;
  mortgageByRegion: { [key: string]: IMortgage };
  // TODO: может быть когда-нибудь пришлют данные по комиссии и гражданству
  // commission?: boolean;
  // citizenship?: Citizenship;
}

export interface IMortgage {
  rate?: string;
  initialInstallment?: number;
  maxLoanTerm?: number;
  minLoanTerm?: number;
  militaryMortgage?: boolean;
}

export enum BANKS_ID {
  sberbank = 7346,
  otkrytie = 7578,
  absolute = 7447,
  vtb = 7289,
  vozrogdenie = 7478,
  uralsib = 7428,
  raifaizen = 7541,
  rosselhozbank = 7307,
  gazprom = 7288,
  santpeterburg = 7295,
  moscov_kredit_bank = 7417,
  metal_investbank = 7441,
  fkotkrytie = 7293,
  tinkoff = 7464,
  zenit = 7300,
  bank_dom_rf = 12448,
  prominvest = 7495,
  sovkombank = 7496,
  svyazbank = 7572,
  alfa_bank = 7290,
}

export const mapBanksFromGKs = (gks: IGk[], banks: IBank[]): IBank[] =>
  banks
    .map(bank => ({
      ...bank,
      gksList: gks.filter(gk => gk.bankIds.includes(bank.id)).map(gk => gk.title),
    }))
    .filter(bank => bank.gksList.length > 0);
